import { render, staticRenderFns } from "./ProductBoxColorVariants.vue?vue&type=template&id=38df0a62&"
import script from "./ProductBoxColorVariants.js?vue&type=script&lang=js&"
export * from "./ProductBoxColorVariants.js?vue&type=script&lang=js&"
import style0 from "./ProductBoxColorVariants.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductBoxColorVariants.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fproduct%2FProductBoxColorVariants%2FProductBoxColorVariants.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports